import { useLazyQuery, useQuery } from "@apollo/client";
import { EMAIL_LOGS } from "../email-log.queries";
import { EmailLogsQuery, EmailLogsQueryVariables } from "../../../__generated__/EmailLogsQuery";

export const useEmailLogs = (variables: EmailLogsQueryVariables) => {
  return useQuery<EmailLogsQuery, EmailLogsQueryVariables>(EMAIL_LOGS, { variables });
};

export const useLazyEmailLogs = () => {
  return useLazyQuery<EmailLogsQuery, EmailLogsQueryVariables>(EMAIL_LOGS);
};
